import { IProps as IButtonProps } from ".";

import { ButtonVariant } from ".";

import styles from "./styles.module.scss";

export const convertPropsToClassNames = (props: IButtonProps) => {
    const classNames: { [key: string]: true } = {};

    // Variant
    switch (props.variant) {
        case ButtonVariant.PRIMARY:
            classNames[styles.primary] = true;
            break;

        case ButtonVariant.SECONDARY:
            classNames[styles.secondary] = true;
            break;

        case ButtonVariant.LINED_PRIMARY:
            classNames[styles.linedPrimary] = true;
            break;

        case ButtonVariant.LINED_SECONDARY:
            classNames[styles.linedSecondary] = true;
            break;

        case ButtonVariant.PAPER:
            classNames[styles.paper] = true;
            break;
    }

    // Size
    if (props.big === true) classNames[styles.big] = true;
    else classNames[styles.small] = true;

    // Icon button
    if (props.icon !== undefined) classNames[styles.withSingleIcon] = true;

    // Left icon
    if (props.leftIcon === undefined) classNames[styles.withoutLeftIcon] = true;
    else classNames[styles.withLeftIcon] = true;

    // Text
    if (props.text === undefined) classNames[styles.withoutText] = true;
    else classNames[styles.withText] = true;

    // Right icon
    if (props.rightIcon === undefined) classNames[styles.withoutRightIcon] = true;
    else classNames[styles.withRightIcon] = true;

    // is button active
    if (props.active === true) classNames[styles.active] = true;
    if (props.active === false) classNames[styles.disable] = true;

    return classNames;
};
